module.exports = __webpack_public_path__ + "static/media/allalerts_test.c05b8026.svg";